<template>
  <div class='custom-link-properties'>
    <div class='custom-link-properties__header'>
      <div>
        <v-icon>link</v-icon>
      </div>
      <div class='custom-link-properties__header__title'>
        <div class='custom-link-properties__header__title__name'>
          {{$t('ctc.properties.link.label')}}
        </div>
        <div class='custom-link-properties__header__title__type'>
          {{$t('ctc.properties.link.direction')}}
        </div>
      </div>
    </div>
    <v-expansion-panels multiple v-model="panels" flat>
      <v-expansion-panel>
        <v-expansion-panel-header class='panel-header'>{{$t('ctc.properties.general.title')}}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="general-content">
            <div class="general-row">
              <div class="link-label">{{$t('ctc.properties.link.label')}}</div>
              <v-text-field
                v-model="label"
                :label="$t('ctc.properties.link.label')"
                solo
                dense
                outlined
                @change="updateLabel"
                class="link-label-input"
              />
            </div>
            <div class="general-row">
              <div class="link-label">{{$t('ctc.properties.link.direction')}}</div>
              <v-btn-toggle
                v-model="direction"
                mandatory
                rounded
                @change="updateDirection"
              >
                <v-btn value="bidirectional" text class='link-button__left'>
                  <v-icon>swap_horiz</v-icon>
                </v-btn>
                <v-btn value="unidirectional" text class='link-button__right'>
                  <v-icon>trending_flat</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'CustomLinkProperties',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({
        label: '',
        bidirectional: true,
        type: 'link',
      }),
    },
  },
  data() {
    return {
      panels: [0],
      label: '',
      direction: 'bidirectional',
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        if (newData) {
          this.label = newData.label || '';
          this.direction = newData.bidirectional ? 'bidirectional' : 'unidirectional';
        }
      },
    },
  },
  methods: {
    updateLabel() {
      this.$emit('property-changed', {
        type: 'link',
        sourceId: this.data.sourceId,
        targetId: this.data.targetId,
        label: this.label,
        bidirectional: this.direction === 'bidirectional',
      });
    },
    updateDirection() {
      this.$emit('property-changed', {
        type: 'link',
        sourceId: this.data.sourceId,
        targetId: this.data.targetId,
        label: this.label,
        bidirectional: this.direction === 'bidirectional',
      });
    },
  },
};
</script>

<style scoped lang='scss'>
@import '~@/assets/styles/design-system';
.custom-link-properties {
  display: flex;
  flex-direction: column;
  margin-top: rem(15);

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: rem(10);

    &__title {
      display: flex;
      flex-direction: column;
      margin-left: rem(15);

      &__name {
        color: var(--text-primary);
        font-family: $font-family-regular;
        font-size: rem(16);
        font-weight: bold;
        letter-spacing: 0;
        line-height: rem(17);
      }

      &__type {
        color: var(--text-tertiary);
        font-family: $font-family-regular;
        font-size: rem(10);
        letter-spacing: 1.1px;
        line-height: rem(15);
        margin-top: rem(5);
        text-transform: uppercase;
      }
    ;
    }
  ;
  }

  .panel-header {
    color: var(--text-primary);
    font-family: $font-family-medium;
    font-size: rem(14);
    letter-spacing: 0;
    line-height: rem(17);
    text-transform: uppercase;
  }

  .general-content {
    padding: rem(10);
  }

  .general-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: rem(15);
    .link-label {
      min-width: rem(100);
      color: var(--text-tertiary);
      font-family: $font-family-regular;
      font-size: rem(10);
      letter-spacing: 1.1px;
      text-transform: uppercase;
      align-items: center;
    }
    .link-label-input{
      margin-top: 0 !important;
    }
    .link-button{
      &__left{
        height: rem(26) !important;
        border-bottom-left-radius: inherit !important;
        border-top-left-radius: inherit !important;
      }
      &__right{
        height: rem(26) !important;
        border-bottom-right-radius: inherit !important;
        border-top-right-radius: inherit !important;
      }
    }
  }
}
</style>
